// urls.py serves both spellings, since the browser drops the fragment on a 301.
const AUTH_CALLBACK_PATHS = ['/auth/callback', '/auth/callback/'];

let stashed: Record<string, string> | null = null;
let nonceStillInUrl = false;

function liftFragment(): Record<string, string> {
  const hash = window.location.hash;
  const stripped = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!stripped) return {};

  const params: Record<string, string> = {};
  new URLSearchParams(stripped).forEach((value, key) => {
    params[key] = value;
  });
  try {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  } catch {
    // Boot path for every social login: a refused strip must not white-screen the app.
    // The nonce is still in the href, so analytics must not boot and stamp it.
    nonceStillInUrl = Boolean(params.nonce);
  }
  return params;
}

// Called from authUrlPreflight before PostHog and Datadog RUM start, both of which stamp
// the full href on every event they send.
export function captureAuthCallbackParams(): void {
  if (!AUTH_CALLBACK_PATHS.includes(window.location.pathname)) return;
  stashed = liftFragment();
}

// True when the fragment could not be stripped, so any SDK that stamps the current URL
// would send the login nonce with every event. Fail closed: skip analytics for this load.
export function authFragmentStripFailed(): boolean {
  return nonceStillInUrl;
}

// Falls back to the live fragment so a mount that bypassed the preflight still logs in.
export function consumeAuthCallbackParams(): Record<string, string> {
  if (stashed === null) return liftFragment();
  const params = stashed;
  stashed = null;
  return params;
}
